/**
 * 图片上传辅助（FormData + Bearer 鉴权）
 */
import { getUploadUrl } from '@/api/common';
import { toBearerHeader } from '@/utils/token';

/** 上传单张图片，返回服务端 URL；失败返回 null */
export async function uploadImage(file: File): Promise<string | null> {
  const form = new FormData();
  form.append('file', file);
  const res = await fetch(getUploadUrl(), {
    method: 'POST',
    headers: { Authorization: toBearerHeader(localStorage.getItem('token')) || '' },
    body: form,
  });
  const data = (await res.json()) as { code?: number; data?: { url?: string } };
  return data?.code === 0 && data?.data?.url ? data.data.url : null;
}
